module.exports = __webpack_public_path__ + "static/media/zhaoyazhi.3275af13.png";